import { create } from 'zustand';

interface Service {
  id: string;
  title: string;
  image: string;
  description: string;
  features: string[];
}

interface CaseStudy {
  id: string;
  title: string;
  image: string;
  summary: string;
  beneficiaries: number;
  duration: string;
  content: string;
  gallery: string[];
}


interface UIState {
  isServiceModalOpen: boolean;
  selectedService: Service | null;
  openServiceModal: (service: Service) => void;
  closeServiceModal: () => void;

  isCaseStudyModalOpen: boolean;
  selectedCaseStudy: CaseStudy | null;
  openCaseStudyModal: (caseStudy: CaseStudy) => void;
  closeCaseStudyModal: () => void;

}

export const useUIStore = create<UIState>((set) => ({
  isServiceModalOpen: false,
  selectedService: null,
  openServiceModal: (service) => set({ isServiceModalOpen: true, selectedService: service }),
  closeServiceModal: () => set({ isServiceModalOpen: false, selectedService: null }),

  isCaseStudyModalOpen: false,
  selectedCaseStudy: null,
  openCaseStudyModal: (caseStudy) => set({ isCaseStudyModalOpen: true, selectedCaseStudy: caseStudy }),
  closeCaseStudyModal: () => set({ isCaseStudyModalOpen: false, selectedCaseStudy: null }),

}));
